<template>
  <div>
    <div class="lxm-nav-container">
      <nav class="level is-mobile lxm-nav">
        <p class="level-item has-text-left lxm-nav__left">
          <!--<img v-if="noHistory"
               class="lxm-nav__left-img lxm-nav__left-img--dashboard"
               src="../../images/main/tab-dashboard-selected.png"
               @click="dashboardClicked" />-->
          <img class="lxm-nav__left-img"
               src="../../images/main/nav-back.png"
               @click="backClicked" />
        </p>
        <transition name="lxm-transition-fade" mode="out-in">
          <template v-if="title">
            <p class="level-item has-text-centered lxm-nav__title">
              {{ title }}
            </p>
          </template>
          <template v-else>
            <lxm-search @click="searchClicked"
                        @submit="searchSubmitted"
                        @input="searchInputted"></lxm-search>
          </template>
        </transition>
        <p class="level-item has-text-right lxm-nav__right">
          <transition name="lxm-transition-small" mode="out-in">
            <template v-if="share">
              <img class="lxm-nav__right-img" src="../../images/main/nav-share.png" @click="shareClicked"/>
            </template>
            <template v-if="menu">
              <img class="lxm-nav__right-img lxm-nav__right-img--menu" src="../../images/main/menu-red.png" @click="menuClicked"/>
            </template>
            <template v-if="qrcode">
              <img class="lxm-nav__right-img lxm-nav__right-img--qrcode" src="../../images/main/nav-qrcode.png" />
            </template>
          </transition>
        </p>
      </nav>
    </div>
    <div class="lxm-nav-placeholder"></div>
    <lxm-menu-panel ref="menuPanel"></lxm-menu-panel>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  nav-height = siz(40)
  .lxm-nav-container
    position: fixed
    z-index: 1
    width: 100vw
    background: brand-secondary
  .lxm-nav
    height: nav-height
    border-bottom: 1px solid white-line
    margin-left: siz(15)
    margin-right: siz(15)
  .lxm-nav__left-img
    width: siz(23)
    height: siz(20.5)
  .lxm-nav__left-img--dashboard
    width: siz(22)
    height: siz(21.5)
  .lxm-nav__right-img
    width: siz(18.5)
    height: siz(19.5)
  .lxm-nav__right-img--qrcode
    width: siz(18.5)
    height: siz(18.5)
  .lxm-nav__right-img--menu
    width: siz(22)
    width: siz(21.5)
  .lxm-nav__left, .lxm-nav__right
    width: siz(35)
    flex-grow: 0 !important
  .lxm-nav__title
    font-size: size-big
    color: grey-darker
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  .lxm-nav-placeholder
    height: nav-height
</style>

<script>
  import LxmSearch from './LxmSearch.vue'
  import LxmMenuPanel from './LxmMenuPanel.vue'
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      LxmSearch,
      LxmMenuPanel
    },
    props: {
      share: Boolean,
      menu: Boolean,
      qrcode: Boolean,
      title: String
    },
    computed: {
      noHistory () {
        return window.history.length <= 1
      }
    },
    methods: {
      backClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK, true)
        if (this.noHistory) {
          /*
          * 测试用链接
          http://m2.com:8088/#/main/contact
          http://m2.com:8088/#/main/form
          http://m2.com:8088/#/main/cf
          http://m2.com:8088/#/main/contact/contact?contactId=ca52k7n48lw9g16p8k4z1dvqpmoxzr3y
          http://m2.com:8088/#/main/contact/contact/info?contactId=ca52k7n48lw9g16p8k4z1dvqpmoxzr3y
          http://m2.com:8088/#/main/contact/contact/log?contactId=ca52k7n48lw9g16p8k4z1dvqpmoxzr3y
          http://m2.com:8088/#/main/form/feedback?formId=canrp7vl4kq139d45vve0m2yxoez5wg8
          http://m2.com:8088/#/main/form/feedback-detail?formId=canrp7vl4kq139d45vve0m2yxoez5wg8&formfillId=car4x83g5ep9wn6r9xwq6mlo1qyzv27k
          http://m2.com:8088/#/main/cf/project?projectId=caxv8z25kyqo768e5vx5g6epgm1rlw94
          http://m2.com:8088/#/main/cf/project/feedback?projectId=caxv8z25kyqo768e5vx5g6epgm1rlw94
          http://m2.com:8088/#/main/cf/project/stat?projectId=caxv8z25kyqo768e5vx5g6epgm1rlw94
          http://m2.com:8088/#/main/cf/feedback-detail?projectId=caxv8z25kyqo768e5vx5g6epgm1rlw94&donateId=cayw3m54kreo807lgr8z8d92vnxglzq7
          http://m2.com:8088/#/main/share?formId=canrp7vl4kq139d45vve0m2yxoez5wg8
          http://m2.com:8088/#/main/share?projectId=caxv8z25kyqo768e5vx5g6epgm1rlw94
          */
          // 使用 replace 防止 noHistory 变为 false 使页面能够逐级退回到主页
          // 实际发现 push 也没有问题，应该是 vue-router 对 history 操作机制的缘故
          const formId = this.$route.query.formId
          const projectId = this.$route.query.projectId
          const activityId = this.$route.query.activityId
          switch (this.$route.path) {
            case '/main/contact':
            case '/main/form':
            case '/main/cf':
              this.$router.replace('/main/dashboard')
              break

            case '/main/contact/contact':
            case '/main/contact/contact/info':
            case '/main/contact/contact/log':
              this.$router.replace('/main/contact')
              break

            case '/main/form/feedback':
              this.$router.replace('/main/form')
              break

            case '/main/form/feedback-detail':
              this.$router.replace({
                path: '/main/form/feedback',
                query: { formId }
              })
              break

            case '/main/cf/project':
            case '/main/cf/project/feedback':
            case '/main/cf/project/stat':
              this.$router.replace('/main/cf')
              break

            case '/main/cf/feedback-detail':
              this.$router.replace({
                path: '/main/cf/project/feedback',
                query: { projectId }
              })
              break

            case '/main/share':
              // no history, ignore feedback-detail
              if (formId) {
                this.$router.replace({
                  path: '/main/form/feedback',
                  query: { formId }
                })
              } else if (projectId) {
                this.$router.replace({
                  path: '/main/cf/project/feedback',
                  query: { projectId }
                })
              } else if (activityId) {
                this.$router.replace({
                  path: '/main/activity/feedback',
                  query: { activityId }
                })
              }
              break

            default:
              this.$router.replace('/main/dashboard')
              break
          }
        } else {
          this.$router.back()
        }
      },
      dashboardClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK, true)
        this.$router.push('/main/dashboard')
      },
      searchClicked () {
        const searchPath = '/main/search'
        if (this.$route.path !== searchPath) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(searchPath)
        }
      },
      shareClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push({
          path: '/main/share',
          query: {
            formId: this.$route.query.formId,
            projectId: this.$route.query.projectId,
            activityId: this.$route.query.activityId
          }
        })
      },
      menuClicked () {
        this.$refs.menuPanel.show()
      },
      searchSubmitted ({ value }) {
        this.$store.dispatch(aTypes.SEARCH, value)
      },
      searchInputted ({ value }) {
        if (!value || value.length < 2) {
          this.$store.commit(mTypes.CLEAR_SEARCH_RESULT)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmNav.vue?292e48a8